import CustomerId              from "../../../../domain/customer/CustomerId";
import CustomerIds             from "../../../../domain/customer/CustomerIds";
import CurrentPage             from "../../../../domain/fundamentals/pagination/CurrentPage";
import MailGroup               from "../../../../domain/mail/group/MailGroup";
import MailGroupId             from "../../../../domain/mail/group/MailGroupId";
import MailGroupName           from "../../../../domain/mail/group/MailGroupName";
import MailGroupRepository     from "../../../../domain/mail/group/MailGroupRepository";
import MailGroups              from "../../../../domain/mail/group/MailGroups";
import { ApiClient }           from "../../../configure/ApiClientConfig";
import {
  addAllMailGroupCustomerAction,
  addMailGroupCustomerAction,
  removeAllMailGroupCustomerAction,
  removeMailGroupCustomerAction,
  setMailGroupAction,
  setMailGroupNameAction
}                              from "../../../redux/mail/group/MailGroupAction";
import { setMailGroupsAction } from "../../../redux/mail/group/MailGroupsAction";

class MailGroupDataSource implements MailGroupRepository {
  constructor(private readonly dispatch) {
  }

  findByPage(currentPage: CurrentPage) {
    return ApiClient.get("/mail/groups", {
      params: {
        page: currentPage.value,
      }
    });
  }

  findAll() {
    return ApiClient.get("/mail/groups/all");
  }

  register(mailGroup: MailGroup) {
    return ApiClient.post("/mail/group", {
      name: mailGroup.name.value,
      customerIds: mailGroup.customerIds.toList().map((customerId: CustomerId) => customerId.value),
    });
  }

  update(mailGroup: MailGroup) {
    return ApiClient.put("/mail/group", {
      id: mailGroup.id.value,
      name: mailGroup.name.value,
      customerIds: mailGroup.customerIds.toList().map((customerId: CustomerId) => customerId.value),
    });
  }

  delete(mailGroupId: MailGroupId) {
    return ApiClient.delete("/mail/group", {
      params: {
        id: mailGroupId.value,
      }
    });
  }

  allSelectedCustomer(customerIds: CustomerIds) {
    this.dispatch(addAllMailGroupCustomerAction(customerIds));
  }

  allUnSelectedCustomer() {
    this.dispatch(removeAllMailGroupCustomerAction())
  }

  setMailGroups(mailGroups: MailGroups) {
    this.dispatch(setMailGroupsAction(mailGroups));
  }

  setMailGroup(mailGroup: MailGroup) {
    this.dispatch(setMailGroupAction(mailGroup));
  }

  setMailGroupName(mailGroupName: MailGroupName) {
    this.dispatch(setMailGroupNameAction(mailGroupName));
  }

  addCustomerId(customerId: CustomerId) {
    this.dispatch(addMailGroupCustomerAction(customerId));
  }

  removeCustomerId(customerId: CustomerId) {
    this.dispatch(removeMailGroupCustomerAction(customerId));
  }
}

export default MailGroupDataSource;
